<template>
  <md-card class="md-card-profile">
    <div class="md-card-avatar">
      <img class="img" :src="cardUserImage"/>
    </div>
    <md-card-content>
      <h6 class="category text-gray">{{user.name}} / {{user.last_name}}</h6>
      <h4 class="card-title">Información Adicional</h4>
      <p class="card-description">
        Teléfono: {{user.phone}}
        Correo Electrónico: {{user.email}}
      </p>
      <md-button class="md-round" :class="getColorButton(buttonColor)">
        Continuar
      </md-button>
    </md-card-content>
  </md-card>
</template>

<script>
  export default {
    name: "user-profile-card",
    props: {
      user: Object,
      cardUserImage: {
        type: String,
        default: process.env.VUE_APP_BASE_URL + "/img/faces/marc.jpg"
      },
      buttonColor: {
        type: String,
        default: ""
      }
    },
    data() {
      return {};
    },
    methods: {
      getColorButton: (buttonColor) => ("md-" + buttonColor + "")
    }
  };
</script>
